export const html: string = `<div data-myon-attr-class="sliderCtl {{ isRange? | '-range' }}">
	<div data-myon-name="channel" class="range_pair -centeredThumb">
		<div data-myon-if="{{ showSpan }}" class="range_spanContainer">
			<div data-myon-attr-class="range_span {{ fillLeft? | '-left' }} {{ fillRight? | '-right' }}" data-myon-name="span"></div>
		</div>
		<input type="range" class="range -tall -centeredThumb sliderCtl_range" data-myon-attr-name="{{ name }}" data-myon-name="range" min="{{ min }}" max="{{ max }}" data-myon-attr-step="{{ step? }}" data-myon-attr-aria-labelledby="{{ labelledBy? }}" data-myon-attr-aria-label="{{ label? }}" data-myon-on-change="handleChange" data-myon-on-input="handleInput" data-myon-on-keyup="handleKeyup" />
		<input type="range" class="range -tall -centeredThumb sliderCtl_range" data-myon-attr-name="{{ name }}" data-myon-name="rangeB" min="{{ min }}" max="{{ max }}" data-myon-attr-step="{{ step? }}" data-myon-attr-aria-labelledby="{{ labelledBy? }}" data-myon-attr-aria-label="{{ label? }}" data-myon-if="{{ isRange }}" data-myon-on-change="handleChange" data-myon-on-input="handleInput" data-myon-on-keyup="handleKeyup" />
	</div>
	<div class="sliderCtl_marks -empty" data-myon-name="markContainer">
		<div class="sliderCtl_mark" data-myon-template="marks">
			<div class="sliderCtl_markOverflow">
				<div class="sliderCtl_markContents" data-myon-name="contents"></div>
			</div>
		</div>
	</div>
	<div class="sliderCtl_labels">
		<div class="sliderCtl_label" aria-hidden="true" data-myon-template="labels" data-myon-attr-style="left: {{ percent | formatPercent }}">{{ label }}</div>
	</div>
</div>`;
